import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 配置文件查询
export default async function configList(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/config/list', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
